import {useAuthStore} from "../store/authStore";
import {getShortToken, parseJwtToken, timestampToLocaleString} from "./token";
import * as Sentry from "@sentry/react";
import {setUserId} from "firebase/analytics";
import {firebaseAnalytics} from "../firebaseConfig";

export const setToken = (token: string, payload: Record<string, any> | null = null) => {
    const jwt_payload = payload ?? parseJwtToken(token)
    useAuthStore.setState({idToken: token, payload: jwt_payload})

    console.info("[Auth] Token has been set successfully");
    console.info("[Auth] Short token:", getShortToken(token))
    console.info("[Auth] Token payload:", jwt_payload);
    console.info("[Auth] Token authentication time:", timestampToLocaleString(jwt_payload?.auth_time));
    console.info("[Auth] Token expires at:", timestampToLocaleString(jwt_payload?.exp));

    setUserId(firebaseAnalytics, jwt_payload.sub);
};


export const clearAuth = () => {
    useAuthStore.setState({idToken: null, payload: null});
    console.info("Auth cleared.");
};

export const addBreadcrumb = (message: string, data: Record<string, any> = {}) => {
    Sentry.addBreadcrumb({
        category: 'auth',
        message,
        data
    });
}
